import React from "react";
import { FiCalendar } from "react-icons/fi";
import "./reportDateFilter.css";

// Shared pieces of the report date filter panel (styles: reportDateFilter.css).
export const DATE_FILTER_PRESETS = [
  "Today",
  "Yesterday",
  "Last 7 Days",
  "Last 30 Days",
];

// Calendar popper class; report workspaces skip it in their generic
// react-datepicker theming so this design applies.
export const DATE_FILTER_POPPER_CLASS = "qv-date-filter-popper";

export const DateFilterHeading = () => (
  <>
    <div className="qv-date-filter__title">
      <FiCalendar aria-hidden="true" />
      <span>Filters</span>
    </div>
    <div className="qv-date-filter__subtitle">Select date range</div>
  </>
);

export const DateFilterPresets = ({
  isActive,
  onSelect,
  options = DATE_FILTER_PRESETS,
}) => (
  <div
    className="qv-date-filter__quick-list"
    role="group"
    aria-label="Date range presets"
  >
    {options.map((option) => (
      <button
        key={option}
        type="button"
        aria-pressed={isActive(option)}
        className={`qv-date-filter__quick${isActive(option) ? " is-active" : ""}`}
        onClick={() => onSelect(option)}
      >
        {option}
      </button>
    ))}
  </div>
);

// Date field that opens the calendar on click without bringing up a keyboard.
export const ReadOnlyDateInput = React.forwardRef(function ReadOnlyDateInput(
  { value, onClick, id },
  ref
) {
  return (
    <input
      ref={ref}
      id={id}
      type="text"
      value={value ?? ""}
      onClick={onClick}
      readOnly
      className="qv-date-filter__input"
    />
  );
});
